import type { ListType } from '../models/app';
import type { GeoLocationType } from '../models/address';

export const customLocationTypeList: {
  id: number;
  label: string;
  shortLabel: string;
  type: number;
  order: number;
}[] = [
  { id: 1, label: 'Custom Location 3#', shortLabel: 'Location 3#', type: 0, order: 1 },
  { id: 2, label: 'Custom Location 4#', shortLabel: 'Location 4#', type: 0, order: 2 },
  { id: 3, label: 'Custom Location 5#', shortLabel: 'Location 5#', type: 0, order: 3 },
  { id: 4, label: 'Custom Location *1', shortLabel: 'Location *1', type: 1, order: 1 },
  { id: 5, label: 'Custom Location *2', shortLabel: 'Location *2', type: 1, order: 2 },
  { id: 6, label: 'Custom Location *3', shortLabel: 'Location *3', type: 1, order: 3 },
  { id: 7, label: 'Custom Location *4', shortLabel: 'Location *4', type: 1, order: 4 },
  { id: 8, label: 'Custom Location *5', shortLabel: 'Location *5', type: 1, order: 5 },
  { id: 9, label: 'Custom Location *6', shortLabel: 'Location *6', type: 1, order: 6 },
  { id: 10, label: 'Custom Location *7', shortLabel: 'Location *7', type: 1, order: 7 },
  { id: 11, label: 'Custom Location *8', shortLabel: 'Location *8', type: 1, order: 8 },
];

export const googleAutocompleteOptionFields: string[] = ['address_component', 'formatted_address', 'geometry', 'name', 'place_id', 'types'];

export const medicalPlaceTypes: string[] = [
  'hospital',
  'doctor',
  'dentist',
  'pharmacy',
  'physiotherapist',
  'veterinary_care',
  'health',
  'medical_lab',
  'chiropractor',
  'dental_clinic',
  'wellness_center',
];

export const defaultMapCenter: GeoLocationType = {
  lat: 37.42248,
  lng: -122.08547,
};

export const countryList: ListType[] = [
  { id: 1, key: 'US', label: 'US' },
  { id: 2, key: 'CA', label: 'CA' },
];

export const usStateList = [
  { name: 'All States', abbreviation: '' },
  { name: 'Alabama', abbreviation: 'AL' },
  { name: 'Alaska', abbreviation: 'AK' },
  { name: 'Arizona', abbreviation: 'AZ' },
  { name: 'Arkansas', abbreviation: 'AR' },
  { name: 'California', abbreviation: 'CA' },
  { name: 'Colorado', abbreviation: 'CO' },
  { name: 'Connecticut', abbreviation: 'CT' },
  { name: 'Delaware', abbreviation: 'DE' },
  { name: 'Florida', abbreviation: 'FL' },
  { name: 'Georgia', abbreviation: 'GA' },
  { name: 'Hawaii', abbreviation: 'HI' },
  { name: 'Idaho', abbreviation: 'ID' },
  { name: 'Illinois', abbreviation: 'IL' },
  { name: 'Indiana', abbreviation: 'IN' },
  { name: 'Iowa', abbreviation: 'IA' },
  { name: 'Kansas', abbreviation: 'KS' },
  { name: 'Kentucky', abbreviation: 'KY' },
  { name: 'Louisiana', abbreviation: 'LA' },
  { name: 'Maine', abbreviation: 'ME' },
  { name: 'Maryland', abbreviation: 'MD' },
  { name: 'Massachusetts', abbreviation: 'MA' },
  { name: 'Michigan', abbreviation: 'MI' },
  { name: 'Minnesota', abbreviation: 'MN' },
  { name: 'Mississippi', abbreviation: 'MS' },
  { name: 'Missouri', abbreviation: 'MO' },
  { name: 'Montana', abbreviation: 'MT' },
  { name: 'Nebraska', abbreviation: 'NE' },
  { name: 'Nevada', abbreviation: 'NV' },
  { name: 'New Hampshire', abbreviation: 'NH' },
  { name: 'New Jersey', abbreviation: 'NJ' },
  { name: 'New Mexico', abbreviation: 'NM' },
  { name: 'New York', abbreviation: 'NY' },
  { name: 'North Carolina', abbreviation: 'NC' },
  { name: 'North Dakota', abbreviation: 'ND' },
  { name: 'Ohio', abbreviation: 'OH' },
  { name: 'Oklahoma', abbreviation: 'OK' },
  { name: 'Oregon', abbreviation: 'OR' },
  { name: 'Pennsylvania', abbreviation: 'PA' },
  { name: 'Rhode Island', abbreviation: 'RI' },
  { name: 'South Carolina', abbreviation: 'SC' },
  { name: 'South Dakota', abbreviation: 'SD' },
  { name: 'Tennessee', abbreviation: 'TN' },
  { name: 'Texas', abbreviation: 'TX' },
  { name: 'Utah', abbreviation: 'UT' },
  { name: 'Vermont', abbreviation: 'VT' },
  { name: 'Virginia', abbreviation: 'VA' },
  { name: 'Washington', abbreviation: 'WA' },
  { name: 'West Virginia', abbreviation: 'WV' },
  { name: 'Wisconsin', abbreviation: 'WI' },
  { name: 'Wyoming', abbreviation: 'WY' },
  { name: 'District of Columbia', abbreviation: 'DC' },
];

export const US_ALIASES = [
  'US',
  'U S',
  'U.S.',
  'USA',
  'U.S.A',
  'U.S.A.',
  'U S A',
  'United States',
  'United States of America',
  'The United States',
  'United States (US)',
  'United States (USA)',
  'America',
];
